import * as React from "react";

import { usePlpDataSourceProductListQuery } from "../plp-data-source-product-list-provider";

interface ProductListFredhopperRedirectsConsumerInterface {
  isRedirecting?: boolean;
}
const defaultValue =
  {} as unknown as ProductListFredhopperRedirectsConsumerInterface;
const ProductListFredhopperRedirectsContext = React.createContext(defaultValue);

interface ProductListFredhopperRedirectsProviderProps {
  providerId: string;
}
export const ProductListFredhopperRedirectsProvider: React.FunctionComponent<
  ProductListFredhopperRedirectsProviderProps
> = (props) => {
  const thisProviderEventNameBase = `bbnt-plp-product-list-fredhopper-redirects-provider-${props.providerId}`;

  const { data } = usePlpDataSourceProductListQuery();

  const [isRedirecting, setIsRedirecting] = React.useState(false);

  const handleFreshPlp = React.useCallback(() => {
    if (isRedirecting) {
      return;
    }

    const howManyPagesOfData = data?.pages?.length || 0;
    if (howManyPagesOfData > 0) {
      const lastPage = data?.pages?.[howManyPagesOfData - 1];
      if (lastPage) {
        const thisRedirect = lastPage.redirect;
        if (thisRedirect && !Array.isArray(thisRedirect)) {
          const thisRedirectUrl = thisRedirect.redirect_url || "";
          if (thisRedirectUrl.length > 0) {
            setIsRedirecting(true);
            window.location.href = thisRedirectUrl;
          }
        }
      }
    }
  }, [data, isRedirecting]);
  React.useEffect(() => {
    window.addEventListener(
      `${thisProviderEventNameBase}-fresh-plp`,
      handleFreshPlp
    );
    return () => {
      window.removeEventListener(
        `${thisProviderEventNameBase}-fresh-plp`,
        handleFreshPlp
      );
    };
  }, [data, handleFreshPlp]);

  React.useEffect(() => {
    window.dispatchEvent(new Event(`${thisProviderEventNameBase}-fresh-plp`));
  }, [data]);

  const value: ProductListFredhopperRedirectsConsumerInterface = React.useMemo(
    () => ({
      isRedirecting,
    }),
    [isRedirecting]
  );
  return (
    <ProductListFredhopperRedirectsContext.Provider value={value}>
      {props.children}
    </ProductListFredhopperRedirectsContext.Provider>
  );
};

export const useProductListFredhopperRedirects = () => {
  const value = React.useContext(ProductListFredhopperRedirectsContext);
  if (value === defaultValue) {
    throw new Error(
      "useProductListFredhopperRedirects must be used within a ProductListFredhopperRedirectsProvider"
    );
  }
  return value;
};
